module.exports = __webpack_public_path__ + "static/img/nav-logo.c8eb6fa3.png";